module.exports = __webpack_public_path__ + "img/helper1.c26841eb.png";